import React from 'react';
import config from '../config';
import bottleCutout from '../assets/ranch-bottle-photo-cut3.png';

// Renders a single rating icon in the configured mode.
// `on` = whether this icon is part of the current fill (1..active).
function RatingIcon({ on }) {
  const mode = config.ratingIcon || 'photo';
  const color = on ? '#facc15' : '#d1d5db';

  if (mode === 'bottle') {
    return (
      <svg className="rtr-icon" width="30" height="34" viewBox="0 0 24 32" style={iconStyle}>
        <rect x="8.5" y="1" width="7" height="3.5" rx="1" fill={color} />
        <rect x="9.5" y="4" width="5" height="3.5" fill={color} />
        <path
          d="M6 9.5 h12 a2 2 0 0 1 2 2 v15.5 a3 3 0 0 1 -3 3 h-10 a3 3 0 0 1 -3 -3 v-15.5 a2 2 0 0 1 2 -2 z"
          fill={color}
        />
        <rect x="7.4" y="14.5" width="9.2" height="6.5" rx="1.5" fill="#ffffff" opacity="0.92" />
      </svg>
    );
  }

  if (mode === 'star') {
    return (
      <svg className="rtr-icon" width="28" height="28" viewBox="0 0 576 512" style={iconStyle}>
        <path
          d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.6-57.4 0z"
          fill={color}
        />
      </svg>
    );
  }

  // Default: photo cutout
  return (
    <img
      className="rtr-icon"
      src={bottleCutout}
      alt=""
      width="34"
      height="62"
      style={{
        display: 'block',
        objectFit: 'contain',
        transition:
          'filter 140ms ease, opacity 140ms ease, transform 240ms cubic-bezier(0.34,1.56,0.64,1)',
        filter: on ? 'none' : 'grayscale(0.85)',
        opacity: on ? 1 : 0.6,
      }}
    />
  );
}

const iconStyle = {
  display: 'block',
  transition: 'transform 240ms cubic-bezier(0.34,1.56,0.64,1)',
};

export default RatingIcon;
